module.exports = __webpack_public_path__ + "img/box-skins-white.5b163a9a.png";